export const CONTACT_LIST = 'CONTACT_LIST';
export const TOGGLE_SIDE_BAR = 'TOGGLE_SIDE_BAR';
export const ADD_CONTACT = 'ADD_CONTACT';
export const UPDATE_CONTACT = 'UPDATE_CONTACT';
export const DELETE_CONTACT = 'DELETE_CONTACT';
export const UPDATE_SELECTED_IDS = 'UPDATE_SELECTED_IDS';
export const PAGINATION_INFO = 'PAGINATION_INFO';
export const UPDATE_CONTACT_LOADER = 'UPDATE_CONTACT_LOADER'
